/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */
import mbpLogger from 'mbp-logger';
import emailSubscription from '../../../../../apis/email-apis/emailSubscription';

const emailSubscriptionAPI = async (jwt, payload) => {
    try {
        const response = await emailSubscription(jwt, payload);
        return response.data;
    } catch (ex) {
        mbpLogger.logError({
            jsError: ex,
            message: 'emailSubscriptionAPI call failed',
        });
        const code = Number(ex.message.substring(ex.message.length - 3));
        return {
            code,
            message: code === 400 ? 'Invalid Email Address' : 'Unable to process the request',
        };
    }
};

export default emailSubscriptionAPI;
